<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Checklist'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <tidy-card>
        <tidy-row>
          <ion-row>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="categoryImage"
                style="width:30px;" />
            </tidy-row>
            <ion-col>
              <tidy-row>
                <tidy-text
                  [header]="(job?.template_data?.job?.service_type_details?.name || job?.template_data?.booking?.bookable_service?.name) | titlecase" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="(job?.template_data?.job?.start_datetime_local | parseDateTime: 'ddd') + ' ' + (job?.template_data?.job?.start_datetime_local | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'at'" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="job?.template_data?.job?.start_datetime_local | parseDateTime: 'h:mma'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-divider />
            </tidy-row>
            <tidy-row class="field-top-padding">
              <form [formGroup]="form">
                <tidy-select
                  [icon]="'assets/svg/list-outline.svg'"
                  [label]="'Checklist'"
                  [form]="form.controls.list"
                  formControlName="list"
                  [items]="toDoFilter"
                  (optionChange)="saveList()" />
              </form>
            </tidy-row>
            @if (selectedList?.description) {
              <tidy-row>
                <tidy-text [body]="selectedList?.description" />
              </tidy-row>
            }
            <tidy-row [align]="'center'">
              @if (usingToDos && !saving) {
                <tidy-text
                  [helper]="'List saved to job.'" />
              }
              @if (!usingToDos && !saving) {
                <tidy-text
                  [helper]="'Changed saved.'" />
              }
              @if (saving) {
                <tidy-text
                  [helper]="'Saving...'" />
              }
            </tidy-row>
          </tidy-card>
          @if (usingToDos) {
            @if (videoInspection === 'Before Videos' || videoInspection === 'Before & After Videos') {
              <tidy-card>
                <tidy-row class="vertical-align-center extra-bottom-padding">
                  <tidy-image
                    [src]="'assets/img/camera.svg'"
                    class='title-size' />
                  <tidy-text
                    [header]="'Remote Inspection'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="videoInspection" />
                </tidy-row>
              </tidy-card>
            }
            @for (room of rooms; track room) {
                <tidy-card class="no-padding">
                  <tidy-card-button [hideArrow]="true" class="no-padding">
                    <tidy-row class="vertical-align-center extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
                      <tidy-text
                        [title]="room?.name" />
                    </tidy-row>
                    <div class="slide-container">
                      @if (room?.photos?.length > 0) {
                        <tidy-carrousel
                          class="photo-notes-carrousel only-padding-bottom">
                          @for (photoNote of room?.photos; track photoNote) {
                            <tidy-photo-note
                              class="full-width there-is-carrousel no-margin"
                              *tidyCarrousel
                              [caption]="photoNote.photo_note_caption"
                              [src]="photoNote.photo_url"
                            />
                          }
                        </tidy-carrousel>
                      }
                    </div>
                    @for (toDo of room?.tasks; track toDo) {
                      @if (!toDo?.task_type?.includes('video')) {
                        <tidy-row class="extra-left-padding extra-right-padding extra-bottom-padding">
                          <span [ngStyle]="toDos.important(toDo?.is_important)" class="vertical-align-center">
                            <tidy-text
                              [body]="toDo?.title" />
                            <!--TODO replace this inline style with a class margin-left-->
                            @if (toDo?.is_important) {
                              <tidy-image
                                style="margin-left: 5px; filter: brightness(0) invert(1)"
                                [src]="'assets/svg/star.svg'" />
                            }
                          </span>
                          @if (toDo?.note !== '') {
                            <tidy-text
                              [helper]="toDo?.note" />
                          }
                        </tidy-row>
                        <div class="slide-container">
                          @if (toDo?.photo_notes?.length > 0) {
                            <tidy-carrousel
                              class="photo-notes-carrousel only-padding-bottom">
                              @for (photoNote of toDo?.photo_notes; track photoNote) {
                                <tidy-photo-note
                                  class="full-width there-is-carrousel no-margin"
                                  *tidyCarrousel
                                  [caption]="photoNote.photo_note_caption"
                                  [src]="photoNote.photo_url"
                                />
                              }
                            </tidy-carrousel>
                          }
                        </div>
                      }
                    }
                  </tidy-card-button>
                </tidy-card>
            }
          }
        }
      </tidy-wrapper>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
